export const blockIconsMapsPinDropNew = (
	<span className='material-symbols-outlined'>pin_drop</span>
);
